import { createContext } from "react";

export const LanguageContext = createContext({
  language: "de",
  languageDispatch: () => {
  },
  languageChanged: false
});
